import { Injectable, effect, signal } from '@angular/core';
import { Sucursal } from '../api/sucursal.service';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  public credentials = signal<string | null>(this.load('credentials'));
  public salaId = signal<string | null>(this.load('salaId'));
  public sala = signal<string | null>(this.load('sala'));
  public sucursal = signal<Sucursal | null>(this.loadJson<Sucursal>('sucursal'));
  public usuarioId = signal<string | null>(this.load('usuarioId'));

  constructor() {
    effect(() => this.save('credentials', this.credentials()));
    effect(() => this.save('salaId', this.salaId()));
    effect(() => this.save('sala', this.sala()));
    effect(() => this.saveJson('sucursal', this.sucursal()));
    effect(() => this.save('usuarioId', this.usuarioId()));
  }

  private load(key: string): string | null {
    try {
      return localStorage.getItem(`cred_${key}`);
    } catch {
      return null;
    }
  }

  private loadJson<T>(key: string): T | null {
    try {
      const val = localStorage.getItem(`cred_${key}`);
      return val ? JSON.parse(val) as T : null;
    } catch {
      return null;
    }
  }

  private save(key: string, value: string | null): void {
    try {
      if (value === null) {
        localStorage.removeItem(`cred_${key}`);
      } else {
        localStorage.setItem(`cred_${key}`, value);
      }
    } catch { /* ignore storage errors */ }
  }

  private saveJson(key: string, value: object | null): void {
    try {
      if (value === null) {
        localStorage.removeItem(`cred_${key}`);
      } else {
        localStorage.setItem(`cred_${key}`, JSON.stringify(value));
      }
    } catch { /* ignore storage errors */ }
  }
}
